<template>
  <div class="card" style="width: 300px;">

    <!--<div class="m-3">
      <img class="infoa is-pulled-right" style="border-radius: 3px; height: 38px;" :src="logo">
      <h1 class="is-size-4">{{ name }}</h1>
      <h2 class="is-size-5 has-text-grey">{{ address }}</h2>
    </div>-->


    <!--<div class="columns bg_gray" style="margin: 5px; border-bottom: solid 2px;">
      <div class="column is-3">
        Day
      </div>
      <div class="column is-4">
        Hours
      </div>
    </div>-->
    <div v-for="hour in Object.keys(hours)" :key="hour" class="columns is-mobile" :style="[(hour != 'Sun') ? {'margin' : '5px', 'border-bottom' : 'solid 1px #ddd'} : {'margin' : '5px'}]">
      <div class="column is-3">
        <strong>{{hour}}</strong>
      </div>
      <div class="column">
        {{hours[hour].open | formatTime}} - {{hours[hour].close | formatTime}}
      </div>
    </div>
  </div>

</template>

<script>

    export default {
      name: 'HourSchedule',
      props: {
        hours: Object,
        name: String,
        address: String,
        logo: String,
      },
      data: function () {
          return {
        }
      },
      methods: {

    },
    computed: {


    }
  }

</script>


<style scoped>

.bg_gray{
  background-color: LightGray;
}

</style>
